module.exports = __webpack_public_path__ + "static/media/ui_detail.aedfd4f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/MobileApp/assets/ui_detail.png
// module id = 552
// module chunks = 0